import { cache, createAsync } from "@solidjs/router";
import {
  Accessor,
  createContext,
  createEffect,
  JSX,
  Show,
  useContext,
} from "solid-js";
import { createStore } from "solid-js/store";
import { Product } from "~/server/types/search";
import {
  getStoreRouteData,
  WebStoreRouteData,
} from "~/server/data/store_route_data";

type StoreProviderProps = {
  children: JSX.Element;
};

interface StoreState {
  brands: Product[];
}

type WebStoreContextValue = {
  storeState: StoreState;
  refreshBrands: () => Promise<void>;
};

const WebStoreContext = createContext<WebStoreContextValue>();

const getStoreRouteData$C = cache(getStoreRouteData, "store");

export function WebStoreContextProvider(props: StoreProviderProps) {
  const routeData: Accessor<WebStoreRouteData | undefined> =
    createAsync<WebStoreRouteData>(() => getStoreRouteData$C());

  const [storeState, setStoreState] = createStore<StoreState>({
    brands: routeData()?.brands as Product[],
  });

  createEffect(() => {
    if (routeData()) {
      setStoreState({
        brands: routeData()?.brands as Product[],
      });
    }
  });

  const refreshBrands = async () => {
    const data = await getStoreRouteData$C();
    setStoreState("brands", data.brands);
  };

  return (
    <WebStoreContext.Provider
      value={{
        storeState,
        refreshBrands,
      }}
    >
      <Show when={routeData()}>{props.children}</Show>
    </WebStoreContext.Provider>
  );
}

export function useWebStoreContext() {
  return useContext(WebStoreContext);
}
